module.exports = __webpack_public_path__ + "static/img/jom-simple-logo-ios-splash-transparent.41161a2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jom-simple-logo-ios-splash-transparent.png
// module id = CC9F
// module chunks = 1